// extracted by mini-css-extract-plugin
export default {"root":"IconLifestyleAndGiftShop_root__raTwS"};